import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useData } from '../../data/DataProvider';
import JobForm from './JobForm';
import EmptyState from '../../shared/components/EmptyState';
import Skeleton from '../../shared/components/Skeleton';

// Page variant of the canonical JobForm — /admin/jobs/:id/edit.
export default function JobEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data, ready } = useData();

  if (!ready) return <div className="standalone-page"><Skeleton rows={8} /></div>;

  const job = data.jobs.find((item) => item.id === id);
  if (!job) {
    return (
      <div className="standalone-page">
        <EmptyState title="Job not found" message="It may have been deleted, or the link is stale." action="Back to jobs" onAction={() => navigate('/admin/jobs')} />
      </div>
    );
  }

  return (
    <JobForm
      variant="page"
      job={job}
      onSaved={() => navigate(`/admin/jobs/${job.id}`)}
    />
  );
}
